// Design-reference savings assumption once usage has ramped up.
export const weeklyFrontDeskHoursSaved = 10;
export const weeklyFrontDeskHoursLabel = `${weeklyFrontDeskHoursSaved}+ hrs`;
export const impactPeriodDays = 90;
export const impactMonthDays = 30;

// Illustrative whole-practice activity for a two-dentist clinic. These are
// scenario inputs, not customer results or revenue attributed to ClawEase.
// Production represents the value of care provided, not profit or cash received.
export const examplePracticeDentists = 2;
// The appointment total is the illustrative floor displayed as “1,200+”.
// Activity builds gradually, then accelerates in the third month.
export const monthlyPracticeAppointments = [240, 360, 600] as const;
export const monthlyPracticeProduction = [80000, 140000, 260000] as const;

const cumulative = (months: readonly number[]) => months.map((_, index) => (
  months.slice(0, index + 1).reduce((total, value) => total + value, 0)
));

export const cumulativePracticeAppointments = cumulative(monthlyPracticeAppointments);
export const cumulativePracticeProduction = cumulative(monthlyPracticeProduction);
export const periodAppointmentsBooked = cumulativePracticeAppointments[cumulativePracticeAppointments.length - 1];
export const periodPracticeProduction = cumulativePracticeProduction[cumulativePracticeProduction.length - 1];
export const firstMonthAppointmentsBooked = monthlyPracticeAppointments[0];
export const chartProductionMaximum = 600000;

export const estimatedThirdMonthHoursSaved = Math.floor(weeklyFrontDeskHoursSaved * impactMonthDays / 7);
// Illustrative monthly estimates, not measured results. Earlier months have
// lower usage; do not apply the month-three weekly rate to all 90 days.
export const estimatedMonthlyHoursSaved = [14, 28, estimatedThirdMonthHoursSaved] as const;
export const estimatedCumulativeHoursSaved = cumulative(estimatedMonthlyHoursSaved);
export const estimatedPeriodHoursSaved = estimatedCumulativeHoursSaved[estimatedCumulativeHoursSaved.length - 1];
